import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nextToPromise } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ViajeEADForm } from "./form";
const ViajeEADFormRx = componentToRx(ViajeEADForm);
type Entity = models.ViajeEAD;
const resource = resources.ViajeEAD;

interface Props {
    match: match<{ id: string }>
}
class ViajeEADEditComp extends React.PureComponent<Props> {
    idStr = (props: Props) => this.props.match.params.id;
    id = createSelectorRx(this.idStr , id => id =="new" ? "new" : Number.parseInt(id) );
    value = createSelectorRx(this.id, id => observeResource(resource.GetViaje, id));


    render() {
        const value = this.value(this.props);
        const id = this.id(this.props);
        return <ViajeEADFormRx value={value} />;
    }
}

export const ViajeEADEdit = withRouter(ViajeEADEditComp);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesEAD/edit/index.tsx